module.exports = __webpack_public_path__ + "static/media/Delete.9d2707a3.svg";